module.exports = __webpack_public_path__ + "img/logo_check_motors.0ca93fa3.png";